<template>
  <transition name="fade" :duration="1000" mode="out-in">
    <div key="loaded" id="app" v-if="loaded">
      <site-navigation
        :numPages="numPages"
        :changePage="changePage"
        :currPage="currPage"
        :changeSorting="changeSorting"
        :sort="sort"
        :places="places"
      />
      <section class="property-row" v-if="paginatedProperties.length === 0">
        Zu diesen Suchkriterien haben wir aktuell keine Objekte.
      </section>
      <!-- <keep-alive :max="10"> -->
        <!-- Könnte interessant sein um die schon geladenen Bilder etc zu cashen -->
      <section v-else class="property-row" v-for="property in paginatedProperties" :key="property.id">
        <h3>{{property.title.value}}</h3>
        <div class="property-content">
          <figure :class="{'no-image': (property.images.length === 0)}">
            <transition class="image" name="fade" appear>
              <img
                v-if="property.images.length > 0"
                :src="property.images[0].medium_url"
                :alt="property.images[0].title"
              />
              <div class="no-image" v-else>Kein Bild verfügbar</div>
            </transition>
          </figure>
          <div>
            <table>
              <tr v-show="property.investment_type.value">
                <td>{{property.investment_type.label}}:</td>
                <td>{{property.investment_type.value}}</td>
              </tr>
              <tr v-show="property.city">
                <td>Ort:</td>
                <td>{{property.city}}</td>
              </tr>
              <tr v-show="property.zip_code">
                <td>PLZ:</td>
                <td>{{property.zip_code}}</td>
              </tr>
              <tr v-show="property.living_space.value">
                <td>Wohnfläche:</td>
                <td>{{property.living_space.value}} m²</td>
              </tr>
              <tr v-show="property.number_of_rooms.value">
                <td>Anzahl Zimmer:</td>
                <td>{{property.number_of_rooms.value}}</td>
              </tr>
              <tr v-show="property.base_rent.value">
                <td>Kaltmiete:</td>
                <td>{{formatCurrency(property.base_rent.value)}}</td>
              </tr>
              <tr v-show="property.total_rent.value">
                <td>Warmmiete:</td>
                <td>{{formatCurrency(property.total_rent.value)}}</td>
              </tr>
              <tr v-show="property.price.value">
                <td>Preis:</td>
                <td>{{formatCurrency(property.price.value)}}</td>
              </tr>
              <tr v-show="property.courtage.value">
                <td>Provision:</td>
                <td>{{property.courtage.value}}</td>
              </tr>
            </table>
            <button @click="detailedProperty = property" class="details-button">Details</button>
          </div>
        </div>
      </section>
      <site-navigation
        :numPages="numPages"
        :changePage="changePage"
        :currPage="currPage"
        :changeSorting="changeSorting"
        :sort="sort"
        :onlyPagination="true"
      />
      <!-- TODO: Error state if loading doesn't succeed -->
      <!-- TODO: Ort (Checkbox); Logo mittig in detailseite; Farben anpassen -->
      <keep-alive>
        <details-popup :property="detailedProperty" :close="closePopup" />
      </keep-alive>
    </div>
    <div v-else-if="error" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background-color: #ff000015; min-height: 400px;">
      Leider gibt es ein Problem mit dem Datenservice von Propstack. Bitte versuchen Sie es später erneut.
    </div>
    <div
      key="loading"
      style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"
      v-else
    >
      <img
        style="margin:auto;display:block;padding: 32px;"
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgNDQgNDQiIHN0cm9rZT0iIzcxYjEwMCI+ICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgIDxjaXJjbGUgY3g9IjIyIiBjeT0iMjIiIHI9IjkuMzgwOTciPiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIGJlZ2luPSIwcyIgZHVyPSIxLjhzIiB2YWx1ZXM9IjE7IDIwIiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlUaW1lcz0iMDsgMSIga2V5U3BsaW5lcz0iMC4xNjUsIDAuODQsIDAuNDQsIDEiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+ICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0ic3Ryb2tlLW9wYWNpdHkiIGJlZ2luPSIwcyIgZHVyPSIxLjhzIiB2YWx1ZXM9IjE7IDAiIGNhbGNNb2RlPSJzcGxpbmUiIGtleVRpbWVzPSIwOyAxIiBrZXlTcGxpbmVzPSIwLjMsIDAuNjEsIDAuMzU1LCAxIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPiAgICAgICAgPC9jaXJjbGU+ICAgICAgICA8Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSIxOS4yMTU2Ij4gICAgICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iLTAuOXMiIGR1cj0iMS44cyIgdmFsdWVzPSIxOyAyMCIgY2FsY01vZGU9InNwbGluZSIga2V5VGltZXM9IjA7IDEiIGtleVNwbGluZXM9IjAuMTY1LCAwLjg0LCAwLjQ0LCAxIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IiBiZWdpbj0iLTAuOXMiIGR1cj0iMS44cyIgdmFsdWVzPSIxOyAwIiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlUaW1lcz0iMDsgMSIga2V5U3BsaW5lcz0iMC4zLCAwLjYxLCAwLjM1NSwgMSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz4gICAgICAgIDwvY2lyY2xlPiAgICA8L2c+PC9zdmc+Cg=="
        alt="Loading Icon"
      />
    </div>
  </transition>
</template>

<script>
import SiteNavigation from './components/SiteNavigation.vue'

// Vielleicht dieses Design:
// https://dribbble.com/shots/10955002-Property-Management-webapp/attachments/2569159?mode=media

export default {
  name: 'App',
  data: () => ({
    error: null,
    properties: [],
    perPage: 20,
    currPage: 1,
    loaded: false,
    detailedProperty: null,
    sort: {
      rent: false,
      priceAsc: false,
      place: null,
      search: ''
    }
  }),
  mounted () {
    this.getProperties().then(res => {
      if (!this.error) {
        this.properties = res
        this.loaded = true
      }
    })
  },
  computed: {
    places () {
      return this.properties
        .filter(
          prop => prop.marketing_type === (this.sort.rent ? 'RENT' : 'BUY')
        )
        .filter(el => !!el.city)
        .map(el => el.city)
        .reduce((prev, curr, idx) => {
          if (!prev.has(curr)) {
            prev.set(curr, 1)
          } else prev.set(curr, prev.get(curr) + 1)
          return prev
        }, new Map())
    },
    numPages () {
      return Math.ceil(this.filteredAndSortedProperties.length / this.perPage)
    },
    paginatedProperties () {
      return this.filteredAndSortedProperties.slice(
        (this.currPage - 1) * this.perPage,
        this.currPage * this.perPage
      )
    },
    filteredAndSortedProperties () {
      return this.properties
        .filter(
          prop => prop.marketing_type === (this.sort.rent ? 'RENT' : 'BUY')
        ) // Buy or rent
        .filter(prop => {
          // Search
          if (this.sort.search) {
            const reg = new RegExp(this.sort.search, 'gi')
            return !!prop.title.value.match(reg)
          } else return true
        })
        .filter(prop => {
          if (this.sort.place === 'all' || this.sort.place === null) {
            return true
          } else return prop.city === this.sort.place
        })
        .sort((a, b) => {
          // sort price
          // which price do I have to sort?
          if (a.price.value && b.price.value) {
            return this.sort.priceAsc
              ? a.price.value - b.price.value
              : b.price.value - a.price.value
          } else if (a.base_rent.value && b.base_rent.value) {
            return this.sort.priceAsc
              ? a.base_rent.value - b.base_rent.value
              : b.base_rent.value - a.base_rent.value
          } else if (typeof a.price.value !== 'number' && typeof a.base_rent.value !== 'number') {
            return 1
          } else if (typeof b.price.value !== 'number' && typeof b.base_rent.value !== 'number') {
            return -1
          } else {
            return 0
          }
        })
    }
  },
  methods: {
    changeSorting (sort) {
      this.sort = sort
    },
    closePopup (ev) {
      this.detailedProperty = null
    },
    changePage (i) {
      this.currPage = i
    },
    async getProperties () {
      try {
        const units = await fetch(
          'https://crm.propstack.de/api/v1/units/?api_key=rCDwSHPh2BMcm8SUqtDwCeep8CoEAxfgP8A7-nRK&status=9305&per=200&expand=true'
        ).then(response => response.json())
          .catch(err => { throw err })
        return units.filter(unit => !!unit.title.value)
      } catch (error) {
        this.error = error
        console.log(error.message)
        return []
      }
    },
    formatCurrency (amount) {
      if (window.Intl && window.Intl.NumberFormat) {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR'
        }).format(amount)
      } else return amount.toString() + ' €'
    }
  },
  components: {
    DetailsPopup: () => import('./components/DetailsPopup.vue'),
    SiteNavigation
  }
}
</script>

<style scoped>
#app {
  background-color: #71b10010;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 8px 0;
  margin: 0;
}

#app .property-row,
#app .site-navigation {
  background-color: #fff;
  max-width: 1000px;
  border-radius: 4px;
  padding: 8px 24px;
  margin: 12px auto;
}

#app .property-row h3 {
  margin-top: 0;
  text-align: left;
}

#app table tr > td:first-child {
  font-weight: bold;
  text-align: left;
}

#app table {
  /* margin: auto; */
}

#app table tr > td:last-child {
  text-align: right;
}

#app table tr {
  vertical-align: text-top;
}

#app .property-content {
  display: flex;
  flex-wrap: wrap;
  margin: -12px -12px;
}

#app .property-content > * {
  flex: 1;
  margin: 12px 12px;
}

#app .property-content > figure {
  background-color: #71b10020;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 103px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOCIgaGVpZ2h0PSIzOCIgdmlld0JveD0iMCAwIDM4IDM4Ij4gICAgPGRlZnM+ICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9IjguMDQyJSIgeTE9IjAlIiB4Mj0iNjUuNjgyJSIgeTI9IjIzLjg2NSUiIGlkPSJhIj4gICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjZmZmIiBzdG9wLW9wYWNpdHk9IjAiIG9mZnNldD0iMCUiLz4gICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjZmZmIiBzdG9wLW9wYWNpdHk9Ii42MzEiIG9mZnNldD0iNjMuMTQ2JSIvPiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNmZmYiIG9mZnNldD0iMTAwJSIvPiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4gICAgPC9kZWZzPiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSI+ICAgICAgICAgICAgPHBhdGggZD0iTTM2IDE4YzAtOS45NC04LjA2LTE4LTE4LTE4IiBpZD0iT3ZhbC0yIiBzdHJva2U9InVybCgjYSkiIHN0cm9rZS13aWR0aD0iMiIgdHJhbnNmb3JtPSJyb3RhdGUoMTQ1LjIwMSAxOCAxOCkiPiAgICAgICAgICAgICAgICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgZnJvbT0iMCAxOCAxOCIgdG89IjM2MCAxOCAxOCIgZHVyPSIwLjlzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPiAgICAgICAgICAgIDwvcGF0aD4gICAgICAgICAgICA8Y2lyY2xlIGZpbGw9IiNmZmYiIGN4PSIzNiIgY3k9IjE4IiByPSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgxNDUuMjAxIDE4IDE4KSI+ICAgICAgICAgICAgICAgIDxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0icm90YXRlIiBmcm9tPSIwIDE4IDE4IiB0bz0iMzYwIDE4IDE4IiBkdXI9IjAuOXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+ICAgICAgICAgICAgPC9jaXJjbGU+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4K");
  height: 250px;
  width: 100%;
  min-width: 386px;
}

#app .property-content > figure.no-image {
  background-image: none;
  outline: none;
}

#app .property-content > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  flex-basis: 21%;
}

#app .details-button {
  padding: 8px;
  background-color: transparent;
  border: 1px solid #71b100;
  color: #71b100;
  text-transform: uppercase;
}

#app .details-button:hover {
  background-color: #71b10020;
  cursor: pointer;
}

#app .details-button:focus,
#app .details-button:active {
  background-color: #71b10020;
  outline: none;
}

#app .property-content figure > * {
  width: 100%;
  height: 100%;
}

#app .property-content figure > img {
  object-fit: cover;
}

#app .no-image {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
  background-color: #71b10020;
  outline: 2px dashed #71b10020;
  outline-offset: 3px;
  color: #71b100;
  padding: 8px;
  box-sizing: border-box;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media only screen and (max-width: 400px) {
  #app .property-row {
    padding: 8px;
  }
}
</style>
